import { object, string } from "yup";

import type { ICommentForm } from "./types";

const MAX_LENGTH = 20000;

const validationSchema = object().shape({
  "comment-editor": string()
    .required("Field cannot be empty")
    .isValidTextBeginning()
    .isValidTextField(),
});

const validatePreSubmit = (values: ICommentForm): { data: ICommentForm } => {
  const comment: string = values["comment-editor"].trim();

  return { data: { "comment-editor": comment } };
};

export { MAX_LENGTH, validationSchema, validatePreSubmit };
